import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { i18n } from "@lingui/core";
import { Trans } from "@lingui/react/macro";

export const Route = createFileRoute("/(public)/not-found")({
  component: NotFoundComponent,
});

function NotFoundComponent() {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <CardTitle className="text-4xl font-bold">404</CardTitle>
          <CardDescription>{i18n._("Page not found")}</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="mb-4 text-(--color-text-secondary)">
            <Trans>The page you're looking for doesn't exist.</Trans>
          </p>
          <Link to="/">
            <Button>
              <Trans>Go home</Trans>
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
